/**
 * STOP! READ ME FIRST!
 * This is the source file for main.bundle.js, which is loaded on every page of the site.
 * Do not add code here that is only needed on a specific page – instead, create a new
 * Webpack JS bundle for that page. See webpack.common.js for examples.
 */
import renderReactClient from './render-react-client';
import SsoButton from './Common/SsoButton/SsoButton';
import PlanPicker from './Common/PlanPicker';
import PDXBanner from './Common/Banner/PDXBanner';
import InternalPlanPicker from './Sponsor/InternalPlanPicker';
import ExploreMyOptionsModal from './Participant/ExploreMyOptionsModal/ExploreMyOptionsModal';
import ManagedAccountWarningModal from './Participant/ManagedAccountWarningModal/ManagedAccountWarningModal';
import ManagedAccountBanner from './Participant/ManagedAccountBanner/ManagedAccountBanner';
import SchwabPCRAModal from './Participant/SchwabPCRAModal/SchwabPCRAModal';
import { reactComponentDirective } from './utils/interop-angular';

let renderCommonComponents = () => {
    renderReactClient({
        ExploreMyOptionsModal,
        PlanPicker,
        SsoButton,
        PDXBanner,
        InternalPlanPicker,
        ManagedAccountBanner,
        ManagedAccountWarningModal,
        SchwabPCRAModal
    });
};

window.npg = window.npg || {};
window.npg.renderCommonComponents = renderCommonComponents;

// call once to render all components on a page
renderCommonComponents();

if (window.npg.ngApp) {
    window.npg.ngApp.directive('managedAccountWarningModal', reactComponentDirective(ManagedAccountWarningModal));
    window.npg.ngApp.directive('managedAccountBanner', reactComponentDirective(ManagedAccountBanner));
}
